import "./overView.css";
import ContentCutIcon from "@mui/icons-material/ContentCut";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import ScheduleIcon from "@mui/icons-material/Schedule";
import { getServicePrice } from "../../models/employees";
import { PersonPinCircleOutlined } from "@mui/icons-material";
export const OverView = ({
  selectedEmployee,
  serviceTimeTotal,
  servicesTotalPrice,
  selectedDateRecord,
  selectedTimeRecord,
  selectedAdditionalServices,
  selectedService,
}) => {
  return (
    <div className="reservationBlock">
      <div className="overViewWrapper">
        <div className="overViewItem">
          <div className="overViewItemIcon">
            <PersonPinCircleOutlined
              className="overViewIcon"
              sx={{ width: 30, height: 30 }}
            />
          </div>
          <span className="overViewItemText">
            <p>Vybraný barber:</p>
            <b>{selectedEmployee.name} | {selectedEmployee.level.toUpperCase()}</b>
          </span>
        </div>
        <div className="overViewItem">
          <div className="overViewItemIcon">
            <ContentCutIcon
              className="overViewIcon"
              sx={{ width: 30, height: 30 }}
            />
          </div>
          <span className="overViewItemText">
            <p>Vybraná služba:</p>
            <b>{selectedService.nazev}</b>
          </span>
        </div>
        {selectedAdditionalServices.length >= 1 && (
          <div className="overViewItem">
            <div className="overViewItemIcon">
              <AddShoppingCartIcon
                className="overViewIcon"
                sx={{ width: 30, height: 30 }}
              />
            </div>
            <span className="overViewItemText">
              <p>Extra služby:</p>
              <div className="overViewServiceTags">
                {selectedAdditionalServices.map((s) => (
                  <span key={s.nazev} className="overViewServiceTag">{s.nazev}</span>
                ))}
              </div>
            </span>
          </div>
        )}
        {selectedDateRecord && (
          <div className="overViewItem">
            <div className="overViewItemIcon">
              <CalendarMonthIcon
                className="overViewIcon"
                sx={{ width: 30, height: 30 }}
              />
            </div>
            <span className="overViewItemText">
              <p>Datum:</p>
              <b>{selectedDateRecord.format("DD.MM.YYYY")}</b>
            </span>
          </div>
        )}
        {selectedTimeRecord && (
          <div className="overViewItem">
            <div className="overViewItemIcon">
              <ScheduleIcon
                className="overViewIcon"
                sx={{ width: 30, height: 30 }}
              />
            </div>
            <span className="overViewItemText">
              <p>Čas:</p>
              <b>{selectedTimeRecord}</b>
            </span>
          </div>
        )}
        <div className="overViewItem">
          <div className="overViewItemIcon">
            <HourglassEmptyIcon
              className="overViewIcon"
              sx={{ width: 30, height: 30 }}
            />
          </div>
          <span className="overViewItemText">
            <p>Délka návštěvy:</p>
            <b>{serviceTimeTotal}min</b>
          </span>
        </div>
        <div className="overViewItem">
          <div className="overViewItemIcon">
            <AttachMoneyIcon
              className="overViewIcon"
              sx={{ width: 30, height: 30 }}
            />
          </div>
          <span className="overViewItemText">
            <p>Cena:</p>
            <b>
              {getServicePrice(selectedEmployee.id, selectedService)
                ? getServicePrice(selectedEmployee.id, selectedService) + servicesTotalPrice
                : servicesTotalPrice}
              Kč
            </b>
          </span>
        </div>
      </div>
    </div>
  );
};
